export enum BroadcastTypes {
  PAY_PER_VIEW = "PAY_PER_VIEW",
  TV = "TV",
  RADIO = "RADIO",
  STREAMING_AUDIO = "STREAMING_AUDIO",
  STREAMING_VIDEO = "STREAMING_VIDEO",
}
